import { Segment, Form, Checkbox } from 'semantic-ui-react';

export const InspectionDetails = ({ assetInspection, handleFieldChange, formErrors, isEdit }) => (
  <Segment>
    <Form.Field>
      <label>Service Needed?</label>
      <Checkbox
        toggle
        checked={assetInspection.serviceNeeded}
        value={assetInspection.serviceNeeded}
        onChange={(e, value) => handleFieldChange('serviceNeeded', value.checked)}
      />
    </Form.Field>
    
    {isEdit && (
      <>
        <Form.Field>
          <label>Inspected By</label>
          <Form.Input className="icct-disabled-input" value={assetInspection?.inspectedByName} />
        </Form.Field>
        <Form.Field>
          <label>Inspection Date</label>
          <Form.Input 
            className="icct-disabled-input" 
            value={assetInspection.inspectionDate ? new Date(assetInspection.inspectionDate).toLocaleDateString() : ""} 
          />
        </Form.Field>
        {assetInspection?.reInspectedByName && (
          <>
            <Form.Field>
              <label>Re-Inspected By</label>
              <Form.Input className="icct-disabled-input" value={assetInspection?.reInspectedByName} />
            </Form.Field>
            <Form.Field>
              <label>Re-Inspection Date</label>
              <Form.Input 
                className="icct-disabled-input" 
                value={assetInspection.reInspectionDate ? new Date(assetInspection.reInspectionDate).toLocaleDateString() : ""} 
              />
            </Form.Field>
          </>
        )}
      </>
    )}

    {assetInspection?.approvedByName && (
      <>
        <Form.Field>
          <label>Approved By</label>
          <Form.Input className="icct-disabled-input" value={assetInspection?.approvedByName} />
        </Form.Field>
        <Form.Field>
          <label>Approved Date</label>
          <Form.Input 
            className="icct-disabled-input" 
            value={assetInspection.approvedDate ? new Date(assetInspection.approvedDate).toLocaleDateString() : ""} 
          />
        </Form.Field>
      </>
    )}
  </Segment>
);